import { render } from "./Pills.vue?vue&type=template&id=eb11ca88&scoped=true"
const script = {}

import "./Pills.vue?vue&type=style&index=0&id=eb11ca88&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb11ca88"]])

export default __exports__